import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface StatCardProps {
  title: string;
  value: string | number;
  icon: React.ReactNode;
  className?: string;
}

const StatCard: React.FC<StatCardProps> = ({ title, value, icon, className }) => {
  return (
    <Card className={cn("border-[0.5px] border-gray-200/50 shadow-[0_2px_8px_-3px_rgba(0,0,0,0.05)]", className)}>
      <CardContent className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-body text-muted-foreground">{title}</p>
            <div className="mt-2 flex items-baseline">
              <p className="text-3xl font-metrics text-foreground">{value}</p>
            </div>
          </div>
          <div className="rounded-full p-2 bg-secondary">
            {icon}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default StatCard;
